import { useSearch } from '../../hooks/context';

const useBottomAds = () => {
  const { bottom_ads } = useSearch();

  return bottom_ads;
};

export default useBottomAds;
